import {
  Button,
  notification,
  Popconfirm,
  Radio,
  RadioChangeEvent,
  Tag,
} from "antd";
import { FC } from "react";
import { IShippingAddress } from "types/address";
import { getFullAddress } from "utils/address";

import { useUpdateShippingAddress } from "services/address";
interface IAddressCardDetail {
  data: IShippingAddress;
  selectedId: number;
}
const AddressCardDetail: FC<IAddressCardDetail> = ({ data, selectedId }) => {
  const { updateShippingAddressAsync } = useUpdateShippingAddress();
  const onChange = (e: RadioChangeEvent) => {
    console.log("radio checked", e.target.value);
  };

  const handleUpdateDefaultShippingAddress = async (id: number) => {
    await updateShippingAddressAsync({ id: id, isDefault: true });
    notification.success({
      message: "แก้ไขที่อยู่หลักสำเร็จ",
      placement: "topRight",
    });
  };

  return (
    <div className="bg-[#F8F8F8] p-4 my-4 flex items-center justify-between">
      <Radio value={data.id} onChange={onChange}>
        <div className="pl-2 text-sm">
          <div>{data.fullName}</div>
          <div>
            {getFullAddress({
              building: data.building,
              moo: data.moo,
              road: data.road,
              address: data.address,
              district: data.district,
              postCode: data.postCode,
              province: data.province,
              subdistrict: data.subdistrict,
            })}
          </div>
          <div>โทร: {data.phoneNumber}</div>
        </div>
      </Radio>
      {data.isDefault ? (
        <Tag color="purple">ค่าเริ่มต้น</Tag>
      ) : (
        <Popconfirm
          title="ต้องการเปลี่ยนที่อยู่หลักใช่หรือไม่"
          onConfirm={() => handleUpdateDefaultShippingAddress(data.id)}
          okText="ใช่"
          cancelText="ยกเลิก"
          okButtonProps={{
            className: "text-sm py-4 px-5",
          }}
          cancelButtonProps={{
            className: "text-sm py-4 px-5",
          }}
        >
          <Button className="p-4" size="small">
            <small>ตั้งเป็นค่าเริ่มต้น</small>
          </Button>
        </Popconfirm>
      )}
    </div>
  );
};
export default AddressCardDetail;
